// @charset "utf-8";
const cookieApi = {
    get (name) {
        var arg = name + '='
        var alen = arg.length
        var clen = document.cookie.length
        var i = 0
        var j = 0
        while (i < clen) {
            j = i + alen
            if (document.cookie.substring(i, j) === arg) {
                var endstr = document.cookie.indexOf(';', j)
                if (endstr === -1) {
                    endstr = document.cookie.length
                }

                var value
                try {
                    value = decodeURIComponent(document.cookie.substring(j, endstr))
                } catch (err) {
                    value = ''
                }

                return unescape(value)
            }
            i = document.cookie.indexOf(' ', i) + 1

            if (i === 0) {
                break
            }
        }
        return null
    },
    set (name, value, exdays) {
        var d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        var expires = 'expires=' + d.toUTCString()
        document.cookie = name + '=' + value + '; ' + expires + '; ' + document.domain + '; /'
    },
    remove (name) {
        this.set(name, '', -1)
    }
}
export default cookieApi



// WEBPACK FOOTER //
// ./src/lib/cookieApi.js